import React from 'react';

import { ForgotPasswordPageLayout } from '@liscio/common';
import { Box } from '@liscio/ui';
import { Helmet } from 'react-helmet-async';

import { ForgotPasswordForm } from './components';
import { Copyright } from '../LoginV5View/components';
import { Link } from 'components';
import { AUTHENTICATE_PAGE_TITLES } from 'modules/authenticate/route-constants';

export const ForgotPasswordView = () => {
  return (
    <>
      <Helmet title={AUTHENTICATE_PAGE_TITLES.forgotPassword} />
      <ForgotPasswordPageLayout
        form={<ForgotPasswordForm />}
        backLink={(
          <Box>
            <Link
              to="/authenticate/login"
              underline="none"
              color={(theme) => theme.palette.text.secondary}
            >
              Back to Log In
            </Link>
          </Box>
        )}
        footer={<Copyright />}
      />
    </>
  );
};
